import apiClient from "../interceptor";

export const statistics = {
    getUsersStats: async () => {
        const response = await apiClient.get("/admin/statistics/users");
        return response.data;
    },

    getPlacesStats: async () => {
        const response = await apiClient.get("/admin/statistics/places");
        return response.data;
    },

    getTransactionsStats: async () => {
        const response = await apiClient.get("/admin/statistics/transactions");
        return response.data;
    },

    getGeneralStats: async () => {
        const response = await apiClient.get("/admin/statistics/general");
        return response.data;
    },
};
